export enum FacebookActionTypes {
  FACEBOOK_ERROR_SYNCING_AD_SETS = "FACEBOOK_ERROR_SYNCING_AD_SETS",
  FACEBOOK_AD_SETS_RECEIVED = "FACEBOOK_AD_SETS_RECEIVED",
  FACEBOOK_START_SYNC_AD_SETS = "FACEBOOK_START_SYNC_AD_SETS",
  FACEBOOK_REFRESH_SELLER_COMPLETED = "FACEBOOK_REFRESH_COMPLETED",
}
